import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { getTopMovers, type Ticker } from "../api/markets";

export function Home() {
  const [movers, setMovers] = useState<Ticker[]>([]);

  useEffect(() => {
    getTopMovers().then(setMovers).catch(() => setMovers([]));
  }, []);

  return (
    <div className="page page-home">
      <section className="hero">
        <h1>
          Trading <span className="accent">intelligence</span>, not noise.
        </h1>
        <p>
          Bitxian aggregates market data, risk regimes, and liquidation flow into a single
          professional surface. Built on Cloudflare for low-latency edge delivery.
        </p>
        <div className="hero-actions">
          <Link to="/markets" className="btn btn-primary">
            Explore markets
          </Link>
          <Link to="/trade/BTCUSDT" className="btn btn-ghost">
            Open trading desk
          </Link>
        </div>
      </section>
      <section className="hero-movers">
        <h2>Top movers</h2>
        <div className="movers-grid">
          {movers.length === 0 && <div className="muted">Loading…</div>}
          {movers.slice(0, 8).map((m) => (
            <Link to={`/trade/${m.symbol}`} key={m.symbol} className="mover-card">
              <div className="mover-symbol">{m.symbol}</div>
              <div className="mover-price">${m.last.toFixed(2)}</div>
              <div className={m.change_24h_pct >= 0 ? "mover-change up" : "mover-change down"}>
                {m.change_24h_pct >= 0 ? "+" : ""}
                {m.change_24h_pct.toFixed(2)}%
              </div>
            </Link>
          ))}
        </div>
      </section>
      <section className="features">
        <div className="feature">
          <h3>Risk regimes</h3>
          <p>Volatility, liquidation pressure, spread anomaly, and exchange divergence at a glance.</p>
        </div>
        <div className="feature">
          <h3>Edge realtime</h3>
          <p>WebSocket fanout via Cloudflare Durable Objects with sub-second updates.</p>
        </div>
        <div className="feature">
          <h3>AI commentary</h3>
          <p>Plain-language regime explanations. Informational, never guaranteed.</p>
        </div>
      </section>
    </div>
  );
}
